export const ROUTES = {
    WELCOME: "/",
    PARENT: "parent",
    ADDRESS: "address",
    STUDENTS: "students",
    CONFIRMATION: "confirmation",
    COMPLETE: "complete",
};
